module.exports = __webpack_public_path__ + "static/media/product1_190313.86f24264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/unused/product1_190313.jpg
// module id = 723
// module chunks = 0